import { FormHelperText } from "@material-ui/core";

import { IUser } from "../../../../types/user/iuser.interface";

import { Autocomplete } from "../../inputs/autocomplete/autocomplete.component";
import { Datepicker } from "../../inputs/date-picker/date-picker.component";
import { matchById } from "../../inputs/autocomplete/autocomplete.functions";

import { FiltersProps } from "../filters.props";
import { useFiltersStyles } from "../filters.styles";

export const FlyerFiltersFields = (props: FiltersProps) => {
  const classes = useFiltersStyles();

  return (
    <>
      <Autocomplete
        control={props.control}
        label="Design Layout Owner"
        limitTags={2}
        name="flyerOwner"
        optionLabel={(user: IUser) => `${user.firstName} ${user.lastName}`}
        optionSelected={matchById}
        options={props.optionLists.users!}
      />
      <div className={classes.dateRange}>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="Start Date"
          name="dateFrom"
        />
        <span>to</span>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="End Date"
          name="dateTo"
        />
      </div>
      {props.errors?.dateTo && (
        <FormHelperText className={classes.error} error={true}>
          {props.errors.dateTo.message}
        </FormHelperText>
      )}
    </>
  );
};
